import { render, staticRenderFns } from "./Editing.vue?vue&type=template&id=4cf64f54&scoped=true&"
import script from "./Editing.vue?vue&type=script&lang=js&"
export * from "./Editing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf64f54",
  null
  
)

export default component.exports